import _get from 'lodash/get'
import _curry from 'lodash/curry'
import _groupBy from 'lodash/groupBy'

const getLocalState = (state) => _get(state, 'likes')
const getEntries = (state) => _get(getLocalState(state), 'entries')
const getEntriesGroupedByKey = _curry((key, state) => _groupBy(getEntries(state), key))
export const getEntriesByRootEntityId = _curry((id, state) => _get(getEntriesGroupedByKey('rootEntityId', state), id))
